import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgRedux, Select, Select$ } from '@angular-redux3/store';
import { Observable } from 'rxjs';
import { map, pluck, withLatestFrom } from 'rxjs/operators';

import { Favorite } from '../../store/entities';
import { AFetchFavorites, APlayFromFavorite, PlaylistRemoteAppState } from '../../store';
import { TimePickerComponent } from '../../components/forms/time-picker/time-picker.component';

@Component({
  selector: 'mwo-favorites',
  templateUrl: './favorites.component.html',
  styleUrls: ['./favorites.component.scss']
})
export class FavoritesPage implements OnInit {
  @Select(['remote', 'name']) playerName$: Observable<string>;
  @Select$('favorites', obs$ => obs$.pipe(
    map(favorites => Object.values(favorites).reduce(
      (acc: Favorite[], favorite: Favorite) => {
        return [...acc, { ...favorite }];
      }, []))
  )) favorites$: Observable<Array<Favorite>>;
  @Select(['player', 'favorite', 'id']) favoriteId$: Observable<string>;
  @Select(['player', 'isPlaying']) isPlaying$: Observable<boolean>;
  private favoriteDurationTime: number;
  constructor(
    private dialog: MatDialog,
    private ngRedux: NgRedux<PlaylistRemoteAppState>,
  ) { }

  ngOnInit() {
    this.ngRedux.dispatch(AFetchFavorites());
  }

  convertToSec(hours: number, minutes: number) {
    return (hours * 3600) + (minutes * 60);
  }

  openTimePicker(id: string): void {
    const favorite$ = this.favorites$.pipe(pluck(id));
    const timePickerRef = this.dialog.open(TimePickerComponent, {});
    timePickerRef.afterClosed().pipe(
      withLatestFrom(favorite$),
    ).subscribe((favoriteRemainsTime: number[]) => {
      if (!favoriteRemainsTime || !favoriteRemainsTime.length || favoriteRemainsTime.reduce((acc, i) => acc + i, 0) <= 0) {
        return favoriteRemainsTime;
      }
      this.favoriteDurationTime = this.convertToSec(favoriteRemainsTime[0][0], favoriteRemainsTime[0][1]);
      this.ngRedux.dispatch(APlayFromFavorite({
        playerContextType: 'FAVORITE', favorite: { id },
        favoriteDurationTime: this.favoriteDurationTime
      }));
    });
  }
}
